export default __webpack_public_path__ + "static/media/how-works.d91a2840.svg";